import React from "react";
import styles from "./nodatafound.module.scss";
// import nodata from "../../styles/images/nodataimg.svg";
import nodata from "../../styles/images/nodataacties.svg";

function NoDataFound() {
  return (
    <>
      <div className={`${styles.nodatafound} nodatafound datacentu` }>
        <div className={styles.nodataimg}>
          {/* <img className={styles.lefticon} src={nodata} alt="" /> */}
          {/* <div> */}
          <img className={styles.lefticon} src={nodata} alt=""/>
          <p>No activities</p>

          {/* </div> */}
        </div>
      </div>
    </>
  );
}

export default NoDataFound;
